export default {
  state: {
    open: ''
  },
  mutations: {
    setOpen: (store, data) => {
      store.open = data
    }
  },
  actions: {
    openForm ({ commit }, { data }) {
      commit('setOpen', data)
    }

  }
}
